export enum CurrencyEnum {
  "THB" = "THB",
  "USD" = "USD",
  "SGD" = "SGD",
  "AUD" = "AUD",
  "HKD" = "HKD",
  "GBP" = "GBP",
  "JPY" = "JPY",
  "EUR" = "EUR",
  "CNY" = "CNY",
}

export interface CurrencyDataInterface {
  currency: CurrencyEnum | string;
  decimalDigits: number;
  sortDecimalDigits: string;
  labelTH: string;
  labelEN: string;
}

export const currencyData: CurrencyDataInterface[] = [
  {
    currency: CurrencyEnum.THB,
    decimalDigits: 2,
    sortDecimalDigits: "฿",
    labelTH: "บาท",
    labelEN: "Thai Baht",
  },
  {
    currency: CurrencyEnum.USD,
    decimalDigits: 2,
    sortDecimalDigits: "$",
    labelTH: "ดอลลาร์สหรัฐ",
    labelEN: "US Dollar",
  },
  {
    currency: CurrencyEnum.SGD,
    decimalDigits: 2,
    sortDecimalDigits: "S$",
    labelTH: "ดอลลาร์สิงคโปร์",
    labelEN: "Singapore Dollar",
  },
  {
    currency: CurrencyEnum.AUD,
    decimalDigits: 2,
    sortDecimalDigits: "AU$",
    labelTH: "ดอลลาร์ออสเตรเลีย",
    labelEN: "Australian Dollar",
  },
  {
    currency: CurrencyEnum.HKD,
    decimalDigits: 2,
    sortDecimalDigits: "HK$",
    labelTH: "ดอลลาร์ฮ่องกง",
    labelEN: "Hong Kong Dollar",
  },
  {
    currency: CurrencyEnum.GBP,
    decimalDigits: 2,
    sortDecimalDigits: "£",
    labelTH: "ปอนด์ สหราชอาณาจักร",
    labelEN: "Great Britain Pound",
  },
  {
    currency: CurrencyEnum.JPY,
    decimalDigits: 0,
    sortDecimalDigits: "¥",
    labelTH: "เยน ญี่ปุ่น",
    labelEN: "Japanese Yen",
  },

  {
    currency: CurrencyEnum.EUR,
    decimalDigits: 2,
    sortDecimalDigits: "€",
    labelTH: "ยูโร",
    labelEN: "Euro",
  },
  {
    currency: CurrencyEnum.CNY,
    decimalDigits: 2,
    sortDecimalDigits: "CNY",
    labelTH: "หยวน จีน",
    labelEN: "Chinese Yuan",
  },
];
